const faqs = [
  {
    q: '97影视需要注册会员才能观看吗？',
    a: '不需要。97影视所有内容均可免费在线观看，无需注册、无需登录，打开网站即可畅享高清观影体验。',
  },
  {
    q: '观看过程中会有广告吗？',
    a: '完全不会。97影视承诺全程无广告干扰，从点击播放到观影结束，你不会看到任何弹窗广告或贴片广告，给你最纯净的观影体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '97影视全面适配电脑、手机、平板等多种设备。无论你使用什么设备，只要打开浏览器即可流畅观看，无需下载任何APP。',
  },
  {
    q: '视频画质怎么样？有高清吗？',
    a: '97影视提供多档清晰度选择，大部分资源支持1080P高清甚至4K画质。默认提供最高清晰度，播放流畅不卡顿，让你享受极致视觉体验。',
  },
  {
    q: '资源更新速度快吗？',
    a: '非常快。热播剧集通常在播出后数小时内完成更新，院线电影也会在窗口期后第一时间上线。每日都有新内容加入，确保你不会错过任何精彩。',
  },
  {
    q: '播放卡顿怎么办？',
    a: '97影视采用先进的CDN加速和多线路播放技术。如果遇到卡顿，可以尝试切换播放线路或降低清晰度。大多数情况下，网络正常即可流畅秒播。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于97影视的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}